import React, { useEffect, useState } from 'react';
import { apiRequest } from '../../../../service/apiRequest';
import {
  Table,
  Button,
  Flex,
  Breadcrumb,
  Form,
  message,
  Popconfirm,
  Space,
  Pagination,
  Switch,
  TableProps,
  Select,
} from 'antd';
import { createStyles } from 'antd-style';
import { HomeOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { theme } from 'antd';
// import WoodModal from './WoodModal';
import { showSuccess, showError } from '../../../../components/errorHandler';
import type { PopconfirmProps, TableColumnsType } from 'antd';
import { useCurrentModule } from '../../../../hooks/useCurrentModule';

import { WoodType } from "../../../../types/WoodType";
import { HPO } from "../../../../types/HPO";


import AddPO from './add-po';
const useStyle = createStyles(({ css }) => ({
  customTable: css`
    .ant-table {
      &-container {
        .ant-table-body,
        .ant-table-content {
          scrollbar-width: thin;
          scrollbar-color: #eaeaea transparent;
        }
      }
    }
  `,
}));


const PurchaseOrder: React.FC = () => {
  const [hpurchaseorders, setHPO] = useState<HPO[]>([]);
  const [form] = Form.useForm();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [initialValues, setInitialValues] = useState<HPO | null>(null);
  const { styles } = useStyle();
  const [pagination, setPagination] = useState<{ current: number; pageSize: number; total: number }>({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const currentModule = useCurrentModule();

  const [filteredInfo, setFilteredInfo] = useState<Record<string, any>>({});
  const [sortedInfo, setSortedInfo] = useState<any>({});
  const [woodtype, setWoodType] = useState<any>({});
  const [woodtypedata, setWoodTypeData] = useState<WoodType[]>([]);


  const cancel: PopconfirmProps['onCancel'] = (e) => {
    console.log(e);
    showError('Click on No');
  };

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const fetchHPO = async (page = 1, limit = 10) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        wood_type: woodtype,
      });

      const data = await apiRequest<HPO[]>({
        method: 'get',
        url: `get-hpo?${params.toString()}`,
      });
      setHPO(data);
    } catch (error) {
      showError('Failed to fetch HPO');
      console.error(error);
    }
  };

  useEffect(() => {
    fetchHPO();
  }, []);

  const handleEditClick = (record: HPO) => {
    setIsEditMode(true);
    setInitialValues({
      pbill_id: record.pbill_id,
      pbill_ledger_id: record.pbill_ledger_id,
      ledger_first_name: record.ledger_first_name,
      ledger_last_name: record.ledger_last_name,
      pbill_bill_no: record.pbill_bill_no,
      pbill_invoice_no: record.pbill_invoice_no,
      pbill_challan_no: record.pbill_challan_no,
      pbill_bill_date: record.pbill_bill_date,
      pbill_status: record.pbill_status,
      pbill_wood_type: record.pbill_wood_type,
      wood_type_name: record.wood_type_name,
      has_napi: record.has_napi,
    });
    setIsModalVisible(true);
  };

  const handleCreate = () => {
    fetchHPO();
  };

  const showCreateModal = () => {
    setIsEditMode(false);
    setInitialValues(null);
    setIsModalVisible(true);
  };

  const hideCreateModal = () => {
    setIsModalVisible(false);
    setIsEditMode(false);
    setInitialValues(null);
  };

  const handleDelete = async (pbill_id: number) => {
    try {
      await apiRequest({
        method: 'delete',
        url: `/delete-hpo/${pbill_id}`,
      });
      showSuccess('HPO deleted');
      fetchHPO();
    } catch {
      showError('Failed to delete HPO');
    }
  };

  const handleStatusToggle = async (widthId: number) => {
    setHPO((prev) =>
      prev.map((item) =>
        item.pbill_id === widthId
          ? { ...item, pbill_status: item.pbill_status === 1 ? 0 : 1 }
          : item
      )
    );

    try {
      await apiRequest({
        method: 'put',
        url: `/update-status-hpo/${widthId}`,
      });
      showSuccess('HPO status updated');
    } catch (error) {
      showError('Failed to update status');
      setHPO((prev) =>
        prev.map((item) =>
          item.pbill_id === widthId
            ? { ...item, pbill_status: item.pbill_status === 1 ? 0 : 1 }
            : item
        )
      );
    }
  };

  const handleTableChange: TableProps<HPO>['onChange'] = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };





  const columns: TableColumnsType<HPO> = [
    // {
    //   title: 'Type',
    //   dataIndex: 'wood_type_name',
    //   key: 'wood_type_name',
    //   render: (_, record) => <div>{record.wood_type_name}</div>,
    // },
    {
      title: 'Company Name',
      dataIndex: 'ledger_first_name',
      key: 'ledger_first_name',
      render: (_, record) => <div>{record.ledger_first_name}</div>,
    },
    {
      title: 'Bill Date',
      dataIndex: 'pbill_bill_date',
      key: 'pbill_bill_date',
      render: (_, record) => <div>{record.pbill_bill_date}</div>,
    },
  ];



  // Conditionally add action column
  if (currentModule?.right_edit === 'Y' || currentModule?.right_delete === 'Y') {
    columns.push({
      title: 'Action',
      width: 200,
      render: (_: any, record: HPO) => (
        <Space size="middle">
          {currentModule?.right_edit === 'Y' && (
            <>
              <Switch
                checkedChildren="Active"
                unCheckedChildren="Inactive"
                checked={!!record.pbill_status}
                onChange={() => handleStatusToggle(record.pbill_id)}
              />
              <Button onClick={() => handleEditClick(record)} className="px-8">
                <EditOutlined />
              </Button>
            </>
          )}
          {currentModule?.right_delete === 'Y' && (
            <Popconfirm
              title="Delete this HPO?"
              onConfirm={() => handleDelete(record.pbill_id)}
              onCancel={cancel}
              okText="Yes"
              cancelText="No"
            >
              <Button danger className="px-8">
                <DeleteOutlined />
              </Button>
            </Popconfirm>
          )}
        </Space>
      ),
    });
  }


  const fetchHPOTypes = async () => {
    try {
      const data = await apiRequest<WoodType[]>({
        method: 'get',
        url: 'wood-types?status=1',
      });
      setWoodTypeData(data);
    } catch (error) {
      showError('Failed to fetch wood type');
      console.error(error);
    }
  };

  useEffect(() => {
    fetchHPOTypes()
  }, []);
  return (
    <>
      <Space
        style={{
          display: 'flex',
          marginBottom: 16,
          alignItems: 'center',
          width: '100%',
          justifyContent: 'space-between',
        }}
      >
        <Breadcrumb style={{ display: 'inline-block', margin: 0 }}>
          <Breadcrumb.Item href="/">
            <HomeOutlined />
          </Breadcrumb.Item>
          <Breadcrumb.Item>View Purchase Order</Breadcrumb.Item>
        </Breadcrumb>
        <Flex gap="small">
          <Flex gap="middle" align="center" style={{ marginBottom: 0, display: 'flex' }} wrap>
            <Select
              onChange={(value) => setWoodType(value)}
              placeholder="Select wood type"
              options={woodtypedata.map(wt => ({ label: wt.wood_name, value: wt.wood_id }))}
            />
          </Flex>
          <Flex gap="small">
            <Button style={{ display: 'flex', alignSelf: 'center' }} type="primary" onClick={() => fetchHPO(1, pagination.pageSize)}>
              Search
            </Button>
          </Flex>
          {currentModule?.right_add === 'Y' && (
            <Flex gap="small" align="center">
              <Button type="primary" onClick={showCreateModal}>
                Add Purchase Order
              </Button>
            </Flex>
          )}
        </Flex>



      </Space>


      <div
        style={{
          minHeight: 360,
          background: colorBgContainer,
          borderRadius: borderRadiusLG,
        }}
      >
        <Table<HPO>
          tableLayout="auto"
          className={`${styles.customTable} scrollable-table`}
          columns={columns}
          onChange={handleTableChange}
          rowKey="pbill_id"
          dataSource={hpurchaseorders.slice(
            (pagination.current - 1) * pagination.pageSize,
            pagination.current * pagination.pageSize
          )}
          bordered
          pagination={false}
          scroll={{ y: 37 * 14 }}
          locale={{ emptyText: 'No Purchase order found' }}
          footer={() => (
            <Flex justify="space-between">
              <span>
                Showing {(pagination.current - 1) * pagination.pageSize + 1}–
                {Math.min(pagination.current * pagination.pageSize, hpurchaseorders.length)} of{' '}
                {hpurchaseorders.length}
              </span>
              <Pagination
                {...pagination}
                total={hpurchaseorders.length}
                showSizeChanger
                onChange={(page, size) => fetchHPO(page, size)}
              />
            </Flex>
          )}
        />
      </div>

      <AddPO
        visible={isModalVisible}
        onCancel={hideCreateModal}
        onCreate={handleCreate}
        isEditMode={isEditMode}
        initialValues={initialValues}
        woodTypesData={woodtypedata}
      />
    </>
  );
};

export default PurchaseOrder;